import styled from 'styled-components';
import { beam } from '@styles/colors/themes';

export const Container = styled.div`
  padding: 24px 32px 32px 32px;
  width: 100%;
  align-self: flex-start;
  margin-top: 6px;
  justify-self: center;
  z-index: 10;
  position: fixed;
  background: #ffffff 0 0 no-repeat padding-box;
  box-shadow: 0 9px 26px #0000003d;

  opacity: 1;
  animation: show 0.2s;
  transform: scale(1);
  grid-template-columns: minmax(min-content, 500px) 1fr;

  @keyframes show {
    from {
      transform: scale(0);
      opacity: 0;
      z-index: -1;
    }
    to {
      transform: scale(1);
      opacity: 1;
      z-index: 2;
    }
  }
`;
interface IInfo {
  maxWidth: number;
}
export const Label = styled.h2`
  color: ${beam.font.primary};
  font-style: normal;
  font-weight: normal;
  font-size: 14px;

  margin-bottom: 0;
  white-space: nowrap;
`;
export const BlueLabel = styled(Label)`
  color: ${beam.font.link};
  margin-right: 40px;
  cursor: pointer;
`;

export const LabelLight = styled(Label)`
  color: ${beam.placeholder.primary};
`;
export const RowDiv = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding-left: 21px;
`;
export const ConfigItem = styled.div<IInfo>`
  display: flex;
  position: relative;
  flex-direction: row;
  width: ${({ maxWidth }) => maxWidth}vw;
  max-width: 14vw;
  align-items: center;
  justify-content: flex-start;
  margin-top: 24px;
  margin-right: 24px;
  border-radius: 4px;
`;
export const TableHeader = styled.div<IInfo>`
  display: flex;
  width: ${({ maxWidth }) => maxWidth}vw;
  max-width: 14vw;
  align-items: center;
  color: #758ca3;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  justify-content: flex-start;
  padding-left: 16px;
  margin-right: 24px;
`;
export const FixedConfigItem = styled.div<IInfo>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-top: 24px;
  margin-right: 16px;
  width: ${({ maxWidth }) => maxWidth}px;
  max-width: 14vw;
  min-width: ${({ maxWidth }) => maxWidth}px;
`;
export const Content = styled.h2`
  color: ${beam.font.primary};
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 16px;
`;

export const Tag = styled.h2`
  color: ${beam.font.primary};
  font-size: 14px;
  font-weight: 400;
  border-radius: 12px;
  background: ${beam.background.tag};
  color: ${beam.color.pureWhite};
  padding: 2px 10px 1px;
`;
export const Header = styled.h1`
  color: ${beam.font.primary};
  font-size: 20px;
  margin-bottom: 16px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-weight: 500;
  align-items: center;
`;
export const CloseButton = styled.div`
  cursor: pointer;
  height: 14px;
  display: flex;
  align-items: flex-end;
  user-select: none;
`;
export const Line = styled.div`
  height: 0;
  width: 100%;
  margin-bottom: 16px;

  /* borders/default-border */
  border-top: 1px solid ${beam.border.back};
`;
export const Input = styled.input`
  border-radius: 8px;
  border: 1px solid #e9edf1;
  background: #fff;
  color: #838a91;
  font-size: 16px;
  padding: 5px 12px;
  width: 100%;
`;

interface IItem {
  active: boolean;
}

export const Item = styled.div<IItem>`
  padding: 4px 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  background: ${({ active }) => (active ? '#F6F8FF' : '#fff')};
  cursor: pointer;
`;
interface IItemListText {
  active: boolean;
}

export const ItemListText = styled.div<IItemListText>`
  font-size: 14px;
  flex: 1;
  color: ${({ active }) => (active ? '#1371FE' : '#1a1b1c')};
`;

export const Buttons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const WindowButtonImage = styled.img``;

export const BlueButton = styled.button`
  :disabled {
    cursor: default;
    opacity: 0.3;
  }
  color: ${beam.color.pureWhite};
  font-size: 14px;
  background: none;
  border: none;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px 7px;

  background: ${beam.color.primaryBlue};
  border-radius: 8px;
`;

export const DateDiv = styled.div`
  /* Layout Properties */
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: start;
  margin-bottom: 16px;
  & .react-date-picker {
    & .react-date-picker__wrapper {
      border: none;
      height: 100%;
      display: flex;
      justify-content: center;
    }
    & .react-calendar {
      width: 400px !important;
      display: table-caption;
    }
  }
`;

export const WindowButton = styled(BlueButton)`
  user-select: none;

  background: ${beam.color.pureWhite};
  color: ${beam.font.primary};
  /* borders/default-border */
  border: 1px solid ${beam.border.back};
  box-sizing: border-box;
  border-radius: 8px;
`;
export const BlueIcon = styled.div`
  display: flex;
  align-items: center;
  font-style: normal;
  font-weight: 900;
  font-size: 16px;
  line-height: 18px;
  text-align: center;
  margin-right: 12px;
  justify-content: center;

  /* beam-colors/beam-accent */
  color: ${beam.color.primaryBlue};
`;
export const GrayIcon = styled.div`
  display: flex;
  align-items: center;
  font-style: normal;
  text-align: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  min-height: 20px;
  min-width: 20px;
  margin-right: 12px;
  font-weight: 900;
  font-size: 11px;
  line-height: 13px;

  /* beam-colors/beam-accent */
  color: ${beam.color.pureWhite};
  background: #758ca3;
  border-radius: 100px;
`;
interface BlackIconProps {
  isHidden?: boolean;
}
export const BlackIcon = styled.nav<BlackIconProps>`
  display: flex;
  position: absolute;
  right: 8px;
  align-items: center;
  visibility: ${({ isHidden }) => (isHidden ? 'hidden' : 'unset')};
  font-style: normal;
  text-align: center;
  justify-content: center;
  cursor: auto;
  font-weight: 900;
  font-size: 12px;
  line-height: 14px;
  z-index: 999;

  /* beam-colors/beam-accent */
  color: transparent;
`;
export const ProfileImg = styled.img`
  width: 64px;
  height: 64px;
  border-radius: 16px;
  object-fit: cover;
`;
export const StyledInput = styled.input`
  height: 32px;
  width: 100%;
  font-size: 14px;
  align-items: start;
  padding-left: 10px;
  padding-right: 8px;
  ::placeholder {
    color: #787878;
  }

  background: #ffffff;
  /* borders/light-border */
  border: 1px solid #d0dae3;
  box-sizing: border-box;
  border-radius: 8px;
`;
export const Block = styled.div`
  background: #fff;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.161);
  border-radius: 8px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
  cursor: auto;
`;
export const Overlay = styled.div`
  /* Layout Properties */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  position: fixed;
  align-content: center;
  justify-content: center;
  z-index: 10;
  /* UI Properties */
  background: #0000003d 0 0 no-repeat padding-box;
  opacity: 1;
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
`;
export const Bar = styled.div`
  padding-top: 5px;
  padding-bottom: 5px;
  background: #f6f8ff;
  border-radius: 8px;
  width: 100%;
  height: 32px;
  display: flex;
  align-items: center;
  z-index: 9;
`;
